// extracted by css-extract-rspack-plugin
export default {"cls1":"Icons-cls1_-QL","cls2":"Icons-cls2_FLr Icons-cls1_-QL"};